import { Button } from "antd";
import type { ReactNode } from "react";

interface EmptyStateProps {
	icon: ReactNode;
	title: string;
	description: string;
	action?: ReactNode;
	actionLabel?: string;
	variant?: "default" | "compact";
	onAction?: () => void;
}

export function EmptyState({
	action,
	actionLabel,
	description,
	icon,
	onAction,
	title,
	variant = "default",
}: EmptyStateProps) {
	const className = variant === "compact" ? "crm-empty-state compact" : "crm-empty-state";

	return (
		<div className={className}>
			<div className="crm-empty-state-icon">{icon}</div>
			<h3>{title}</h3>
			<p>{description}</p>
			{action ??
				(actionLabel && onAction ? (
					<Button type="primary" className="crm-primary-btn" onClick={onAction}>
						{actionLabel}
					</Button>
				) : null)}
		</div>
	);
}
